import unparkRoutes from './routes'

/* @ngInject */
const unparkRun = (
  $transitions,
  $state,
  storageHandler,
  $$wagon,
  $$train,
  $$railway,
  constants,
  maneuverMenu
) => {
  $transitions.onSuccess({
    entering: unparkRoutes.index.path,
  }, (trans) => {
    maneuverMenu.radio.value = 'unparkMenu'

    const step = storageHandler.get('maneuver.unpark.step')

    if (step === 'selectWagons') {
      $state.go(unparkRoutes.selectWagons.path)
    } else if (step === 'createTrain') {
      $state.go(unparkRoutes.createTrain.path)
    } else if (step === 'report') {
      $state.go(unparkRoutes.report.path)
    } else if (!step) {
      $state.go(unparkRoutes.selectWagons.path)
    }
  })

  $transitions.onSuccess({
    entering: unparkRoutes.selectWagons.path,
  }, async (trans) => {
    if (storageHandler.get('maneuver.unpark.mySelectedWagons')) {
      $$wagon.data.mySelectedWagons = storageHandler.get('maneuver.unpark.mySelectedWagons')
    } else {
      $$wagon.data.mySelectedWagons.splice(0, $$wagon.data.mySelectedWagons.length)
    }

    if (storageHandler.get('maneuver.unpark.mySearchedWagons')) {
      $$wagon.data.mySearchedWagons = storageHandler.get('maneuver.unpark.mySearchedWagons')
    } else {
      $$wagon.data.mySearchedWagons.splice(0, $$wagon.data.mySearchedWagons.length)
    }

    if (storageHandler.get('maneuver.unpark.mySelectedIds')) {
      $$wagon.data.mySelectedIds = storageHandler.get('maneuver.unpark.mySelectedIds')
    } else {
      $$wagon.data.mySelectedIds.splice(0, $$wagon.data.mySelectedIds.length)
    }

    if (storageHandler.get('maneuver.unpark.mySelectedLength')) {
      $$wagon.data.mySelectedLength = storageHandler.get('maneuver.unpark.mySelectedLength')
    } else {
      $$wagon.data.mySelectedLength = 0
    }

    if (storageHandler.get('maneuver.unpark.myDepartureRailway')) {
      $$railway.data.myDepartureRailway = storageHandler.get('maneuver.unpark.myDepartureRailway') || {}
    } else {
      $$railway.data.myDepartureRailway = {}
    }

    storageHandler.save('maneuver.unpark.myTrain', $$train.new.classic())
    $$railway.data.departureRailways = await $$railway.request.getByArea(constants.ids.departureRailway)
  })

  $transitions.onBefore({
    exiting: unparkRoutes.selectWagons.path,
  }, (trans) => {
    storageHandler.save('maneuver.unpark.mySearchedWagons', $$wagon.data.mySearchedWagons)
    storageHandler.save('maneuver.unpark.mySelectedWagons', $$wagon.data.mySelectedWagons)
    storageHandler.save('maneuver.unpark.mySelectedIds', $$wagon.data.mySelectedIds)
    storageHandler.save('maneuver.unpark.mySelectedLength', $$wagon.data.mySelectedLength)
    storageHandler.save('maneuver.unpark.myDepartureRailway', $$railway.data.myDepartureRailway || {})
    storageHandler.save('maneuver.unpark.step', 'selectWagons')

    $$wagon.data.mySearchedWagons.splice(0, $$wagon.data.mySearchedWagons.length)
    $$wagon.data.mySelectedWagons.splice(0, $$wagon.data.mySelectedWagons.length)
    $$wagon.data.mySelectedIds.splice(0, $$wagon.data.mySelectedIds.length)
    $$wagon.data.mySelectedLength = 0
    $$railway.data.myDepartureRailway = {}
  })

  $transitions.onSuccess({
    entering: unparkRoutes.createTrain.path,
  }, (trans) => {
    if (storageHandler.get('maneuver.unpark.myTrain')) {
      $$train.data.myTrain = $$train.format.user(storageHandler.get('maneuver.unpark.myTrain'))
    } else {
      $$train.data.myTrain = $$train.new.classic()
    }

    if (storageHandler.get('maneuver.unpark.mySelectedIds')) {
      $$wagon.data.mySelectedIds = storageHandler.get('maneuver.unpark.mySelectedIds')
    } else {
      $$wagon.data.mySelectedIds.splice(0, $$wagon.data.mySelectedIds.length)
    }

    if (storageHandler.get('maneuver.unpark.mySelectedLength')) {
      $$wagon.data.mySelectedLength = storageHandler.get('maneuver.unpark.mySelectedLength')
    } else {
      $$wagon.data.mySelectedLength = 0
    }
  })

  $transitions.onBefore({
    exiting: unparkRoutes.createTrain.path,
  }, (trans) => {
    storageHandler.save('maneuver.unpark.myTrain', $$train.data.myTrain)
    storageHandler.save('maneuver.unpark.step', 'createTrain')
    $$train.data.myTrain = null
  })

  $transitions.onSuccess({
    entering: unparkRoutes.report.path,
  }, async (trans) => {
    $$wagon.data.myWagonIds.splice(0, $$wagon.data.myWagonIds.length)
    $$wagon.data.mySelectedWagons.splice(0, $$wagon.data.mySelectedWagons.length)
    $$wagon.data.mySearchedWagons.splice(0, $$wagon.data.mySearchedWagons.length)

    if (storageHandler.get('maneuver.unpark.myTrain')) {
      $$train.data.myTrain = storageHandler.get('maneuver.unpark.myTrain')
    }
  })

  $transitions.onBefore({
    exiting: unparkRoutes.report.path,
  }, (trans) => {
    storageHandler.save('maneuver.unpark.step', 'report')
    storageHandler.save('maneuver.unpark.mySearchedWagons', [])
    storageHandler.save('maneuver.unpark.mySelectedWagons', [])
    storageHandler.save('maneuver.unpark.mySelectedIds', [])
    storageHandler.save('maneuver.unpark.myDepartureRailway', {})
  })
}

export default unparkRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/unpark/unpark.run.js